if ($('#vtex-callcenter__toolbar').length) {
  $('body').addClass('is-callcenter');
}
window.$(document).on('DOMNodeInserted', '#vtex-callcenter__toolbar', function (e) {
  $('body').addClass('is-callcenter');
  function setNativeValue(element, value) {
    let lastValue = element.value;
    element.value = value;
    // @ts-ignore
    let event = new Event('input', { target: element, bubbles: true });
    // React 15
    // @ts-ignore
    event.simulated = true;
    // React 16
    let tracker = element._valueTracker;
    if (tracker) {
      tracker.setValue(lastValue);
    }
    element.dispatchEvent(event);
  }
  var $toolbar = $(e.target);
  var $impersonateButton = $('#impersonateButton');
  if ($toolbar.find('#vtex-callcenter__customer-email').length) {
    $('#custom-impersonateButton').remove();
    $impersonateButton.show();
    return;
  }
  if (
    $toolbar.find('#custom-impersonateButton').length ||
    ($toolbar.text().indexOf('Entrar como') === -1 && $toolbar.text().indexOf('Trocar de cliente') === -1) ||
    $toolbar.text().indexOf('Trocar de cliente') > -1
  ) {
    return;
  }
  var $form = $(
    '<form id="impersonationForm-custom" class="cc-relative cc-fadeIn cc-impersonate cc-ma0 cc-pa0" style="display: none">' +
      '<div class="cc-absolute cc-w-80 cc-w-30-ns cc-z-9999" style="top: 5rem; right: 1em;">' +
      '<h4 class="cc-bg-dark-gray cc-ma0 cc-pv3 cc-tc cc-light-silver cc-fw6 cc-br3 cc-br--top"><span>Personificar</span></h4>' +
      '<div class="cc-ba-ns cc-pt3 cc-pb4 cc-ph3 cc-br3 cc-br--bottom cc-bg-white">' +
      '<label for="televendas-email" class="cc-f6 cc-db cc-gray cc-mb1 cc-fw5">E-mail ou CPF (sem prontuações):</label>' +
      '<div class="cc-relative">' +
      '<input type="text" id="vtex-callcenter__customer-email-input-custom" class="cc-pv2 cc-ph2 cc-ba-ns cc-b--silver cc-black-80 cc-w-100 cc-mb2 cc-f5 cc-h2" value="" style="margin-top: 0px;">' +
      '</div>' +
      '<button id="vtex-callcenter__customer-login-submit-custom" class="cc-pointer cc-lh-copy cc-db cc-br2 cc-bw0 cc-ph3 cc-pv2 cc-dib cc-ttu cc-fw7 cc-f7 cc-bg-green cc-white cc-dim">' +
      '<span>Pesquisar</span>' +
      '</button>' +
      '<div id="cc-list-of-users" class="cc-w-100 cc-pv3 cc-dib" style="max-height: 300px;overflow: auto;"></div>' +
      '</div>' +
      '</div>' +
      '</form>',
  );
  var $customImpersonateButton = $(
    '<a href="#" id="custom-impersonateButton" class="cc-fr-ns cc-mt1 cc-mt0-ns cc-link cc-br2 cc-ba cc-pa0 cc-w-20-ns cc-ph3-ns cc-ba-ns cc-pv2-ns cc-db cc-dib-ns cc-tc cc-ttu cc-fw7 cc-f7 cc-dim cc-btn-login cc-light-green cc-mr2 cc-ml2">Buscar usuário</a>',
  );

  $customImpersonateButton.on('click', function (event) {
    event.preventDefault();
    $form.toggle();
  });

  $(document).on('click', '[data-cc-auth-with]', function (event) {
    event.preventDefault();
    var $this = $(event.currentTarget);
    var email = $this.attr('data-cc-auth-with');
    $('#ajaxBusy').show();
    $form.hide();
    setTimeout(function () {
      // @ts-ignore
      document.querySelector('#impersonateButton')?.click();
      setTimeout(function () {
        setNativeValue(document.querySelector('#vtex-callcenter__customer-email-input'), email);
        setTimeout(function () {
          // @ts-ignore
          document.querySelector('#vtex-callcenter__customer-login-submit')?.click();
        }, 300);
      }, 300);
    }, 300);
  });

  $form.on('submit', function (event) {
    event.preventDefault();
    var $input = $('#vtex-callcenter__customer-email-input-custom');
    var inputValue = $input.val().trim();
    if (!inputValue) {
      $input.css({ borderColor: 'red' }).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
      setTimeout(function () {
        $input.removeAttr('style');
      }, 1000);
      return;
    }
    const $content = $form.find('#cc-list-of-users');
    $content.html('Aguarde...');
    $.getJSON(
      '/swiftbr/dataentities/CL/search/?_where=(document=*' +
        inputValue +
        '*%20OR%20email=*' +
        inputValue +
        '*)&_fields=email,document',
    )
      .done(function (data) {
        if (!data && !data.length) {
          $content.html('Nenhum usuário encontrado para esta busca');
          return;
        }
        var table =
          '<table class="table cc-w-100"><tr style="background: #DDD;color: #000;"><th>Documento</th><th>E-mail</th><th></th></tr>';
        table += data
          .map(function (item) {
            return (
              '<tr><td>' +
              item.document +
              '</td><td>' +
              item.email +
              '</td><td><a data-cc-auth-with="' +
              item.email +
              '" href="#">Autenticar-se</a></td></tr>'
            );
          })
          .join('');
        table += '</table>';
        $content.html(table);
      })
      .fail(function () {
        $content.html('Houve um erro ao pesquisar por este valor. Verifique os dados digitados e tente novamente');
      });
  });
  $impersonateButton.hide();
  $customImpersonateButton.insertAfter($impersonateButton);
  $toolbar.append($form);
});

export default {};
